import { isNil } from 'lodash-es';
import * as tagsService from 'services/tagService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { Paginator } from 'services/dtoModels/paginator';
import type { GetTagsRequest } from 'services/dtoModels/tags/getTagsRequest';
import type { SWRResponse } from 'swr';

type SWRProductsData = Awaited<ReturnType<typeof tagsService.getTagsAsync>>;
export const SWR_PRODUCT_TAGS_ENDPOINT = 'tags';

export default function useTags(
  params: GetTagsRequest & Paginator,
  load = true
): SWRResponse<SWRProductsData, AxiosError> {
  return useSWR(
    !isNil(load) && load ? [SWR_PRODUCT_TAGS_ENDPOINT, params] : null,
    async ([_key, params]) => await tagsService.getTagsAsync(params)
  );
}
